import React from 'react';
import PropTypes from 'prop-types';
import CharacterNav from './CharacterNav';
import cx from 'classnames';

import './CharacterPicker.scss';

const CharacterPicker = props => (
  <div
    className={cx('character-picker', {
      'character-picker--transformed': props.needsTransform,
    })}>
    <div
      className="character-picker-inner"
      style={{	
        transform: props.transform,	
        WebkitTransform: props.transform,	
      }}>
      {props.items.map((item, index) => (
        <CharacterNav
          key={index}
          letter={item.letter}
          characters={item.characters}
          defaultCharacter={item.defaultCharacter}
          characterIndex={index}
          setActiveNav={props.setActiveNav}
          isActive={props.activeNav === index}
          setActivePage={props.setActivePage}
          activePage={props.activePage}
          id={item.index + 2}
          onChangeCharacter={props.handleChangeCharacter}
          values={props.values}
          isHeidelberg={props.isHeidelberg}
          prismicContent={props.prismicContent}
        />
      ))}
    </div>
  </div>
);

CharacterPicker.propTypes = {
  prismicContent: PropTypes.object.isRequired,
  transform: PropTypes.string,
  items: PropTypes.array.isRequired,
  setActiveNav: PropTypes.func.isRequired,
  activeNav: PropTypes.number,
  setActivePage: PropTypes.func.isRequired,
  handleChangeCharacter: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  needsTransform: PropTypes.bool.isRequired,
  activePage: PropTypes.number,
  isHeidelberg: PropTypes.bool.isRequired,
};

export default CharacterPicker;



// WEBPACK FOOTER //
// ./src/client/js/view/components/CharacterPicker/CharacterPicker.js